// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__uPQdb","spin":"Spinner_spin__lgsq6"};